import { render, staticRenderFns } from "./SpecialBiwako202402.vue?vue&type=template&id=d023a54c&scoped=true"
import script from "./SpecialBiwako202402.vue?vue&type=script&lang=js"
export * from "./SpecialBiwako202402.vue?vue&type=script&lang=js"
import style0 from "./SpecialBiwako202402.vue?vue&type=style&index=0&id=d023a54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d023a54c",
  null
  
)

export default component.exports